<script lang="ts">
    import {getDateFormatter, getInjector, getLocalization} from 'src/core';
    import {pipe} from 'core/utils';
    import {KpFooterService} from './kp-footer.service';

    const service = getInjector().getByClass(KpFooterService);

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
</script>

<div class="version">
    {localize(/* @kp-localization commons.VerzeSystemu */ 'commons.VerzeSystemu')}
    {pipe(service.portaroVersion.date, dateFormatter('d.M.yyyy H:mm:ss'))}
    ({service.portaroVersion.branch} {service.portaroVersion.value})
</div>